import { render, staticRenderFns } from "./ForcesTable.vue?vue&type=template&id=4e2410d9&lang=pug&"
import script from "./ForcesTable.vue?vue&type=script&lang=ts&"
export * from "./ForcesTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports